import { MyGroupingOfArticlePropDTO, ViewerArticleClient, ArticleModel, MoveArticlesClient, IViewerArticleClient, IMoveArticlesClient, ArticleMoveDTO } from "../Generated/ParticaAPI";
import { ParticaItem, ParticaSubItem } from "@/Models/ParticaItem";
import { IExtractedArticle } from "@/Models/ArticleModels/article";
import { ArticleUtils } from "./articleutils";

export interface IViewerArticleService {
	getArticlesBySection(issueId: number): Promise<ParticaItem[]>;
	getArticle(issueId: number, articleId: string): Promise<IExtractedArticle>;
	saveArticle(article: IExtractedArticle): Promise<IExtractedArticle>;
	moveArticle(articleId: string, sectionId: number, issueId: number): Promise<any>;
	moveArticles(articleIds: string[], sectionId: number, issueId: number): Promise<any>;
}

export class ViewerArticleService implements IViewerArticleService {
	private svc: IViewerArticleClient = new ViewerArticleClient();
	private movesvc: IMoveArticlesClient = new MoveArticlesClient();
	private articleUtils: ArticleUtils = new ArticleUtils();

	public async saveArticle(article: IExtractedArticle): Promise<IExtractedArticle> {
		let am = article.get<ArticleModel>();
		am.issue = undefined;
		am = await this.svc.saveArticle(am);
		return this.articleUtils.convertarticle<IExtractedArticle>(am);
	}

	public async moveArticles(articleIds: string[], sectionId: number, issueId: number) {
		const moveDetails = new ArticleMoveDTO();
		moveDetails.articleGuids = articleIds;
		moveDetails.sectionId = sectionId;
		moveDetails.issueId = issueId;
		await this.movesvc.moveArticles(moveDetails);
	}
	public async moveArticle(articleId: string, sectionId: number, issueId: number) {
		const moveDetails = new ArticleMoveDTO();
		moveDetails.articleGuids = [articleId];
		moveDetails.sectionId = sectionId;
		moveDetails.issueId = issueId;
		await this.movesvc.moveArticles(moveDetails);
	}

	public async getArticle(issueId: number, articleId: string): Promise<IExtractedArticle> {
		const article: ArticleModel = await this.svc.getArticle(issueId, articleId);
		const extracted: IExtractedArticle = this.articleUtils.convertarticle<IExtractedArticle>(article);
		return extracted;
	}

	public async getArticlesBySection(issueId: number): Promise<ParticaItem[]> {
		const sections: MyGroupingOfArticlePropDTO[] = await this.svc.getArticlesBySection(issueId);
		const result: ParticaItem[] = [];
		sections.forEach(section => {
			const item: ParticaItem = { id: section.id, name: section.name, items: [], open: false, children: [] } as ParticaItem;
			if (section.elements !== undefined) {
				section.elements.forEach(element => {
					if (element.parentId !== undefined) {
						const sub: ParticaSubItem = {
							id: element.articleId, name: element.title, parentid: element.parentId.toString(), optional: "", icon: ""
						} as ParticaSubItem;
						item.items.push(sub);
					}
				});
			}
			result.push(item);

		});
		return result;

	}
}
